import { render, staticRenderFns } from "./ProvisionPreview.vue?vue&type=template&id=6bf4975e&scoped=true"
import script from "./ProvisionPreview.vue?vue&type=script&lang=js"
export * from "./ProvisionPreview.vue?vue&type=script&lang=js"
import style0 from "./ProvisionPreview.vue?vue&type=style&index=0&id=6bf4975e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf4975e",
  null
  
)

export default component.exports